import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { PageLoaderFullScreen } from 'remote/global';

function DocumentationRedirectView() {
  const navigate = useNavigate();

  useEffect(() => {
    window.open('https://docs.mobifer.com/', '_blank');
    navigate(-1);
  }, [navigate]);

  return <PageLoaderFullScreen />;
}

export default DocumentationRedirectView;
